import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Aplicacion } from '../shared/aplicacion.model';
import { TYPEMODULE, LoaderService, NotificationService,UtilityService, ErrorService, TYPEMESSAGE } from '../../../../shared/session/index';
import { AplicacionService } from '../shared/aplicacion.service';

@Component({
	//moduleId: module.id,
	selector: 'app-aplicacion-view',
	templateUrl: 'aplicacion-view.component.html'
})
export class ApplicationViewComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() typeModule: TYPEMODULE;
  @Input() titlePage: string;
  @Input() data: any;
  // @Input()  ID:number;


  aplicacion: Aplicacion;
  msgErrorGet: string;

  constructor(private loaderService: LoaderService,
    private applicationService: AplicacionService,
      private errorService: ErrorService,
      private NotificationService: NotificationService,
      private utilityService: UtilityService) { }

  ngOnInit() {
      this.aplicacion = new Aplicacion( 0, "","","","",false,"admin","","admin","");
      this.msgErrorGet = 'Error al obtener datos';
       this.obtenerApplication(this.data.aplicacion.ID);
   }

  private obtenerApplication(ID: number): void {
    this.loaderService.show();
    this.applicationService.obtenerApplication(ID)
    .subscribe(res => {
        this.aplicacion = res;
        this.utilityService.setAuditoria(this.aplicacion);
    },
    error => {
        this.NotificationService.error(this.msgErrorGet);
        throw error;
    },
    () => {
        this.loaderService.hide();
    });
  }
}
